import products from '@/config/products'
import HeroHeader from '@/pages/Home/HeroHeader'
import ProductTile from '@/pages/Home/ProductTile'
import UserMenu from '@/pages/Home/UserMenu'

const Home = () => (
  <main className='bg-neutral-dimmed min-h-screen'>
    <div className='absolute top-4 right-8 z-50 flex items-center gap-3'>
      <UserMenu />
    </div>

    <HeroHeader />

    <section className='mt-8 grid gap-4 px-8 pb-4 md:[grid-template-columns:repeat(auto-fill,minmax(200px,1fr))] md:gap-6 md:px-10 md:pb-6 lg:[grid-template-columns:repeat(auto-fill,minmax(200px,1fr))] lg:gap-8 lg:px-20 lg:pb-8 xl:grid-cols-4 xl:gap-10 2xl:grid-cols-4'>
      {products
        .filter((p) => !p.hidden)
        .map((p) => (
          <ProductTile key={p.id} product={p} />
        ))}
    </section>
  </main>
)

export default Home
